import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

var _excluded = ["icon", "height", "width", "className", "variant"];
var VariantIcon = function VariantIcon(_ref) {
  var icon = _ref.icon,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '56' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '56' : _ref$width,
    className = _ref.className,
    variant = _ref.variant,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if ( /*#__PURE__*/React.isValidElement(icon)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(icon, Object.assign({
      height: height,
      width: width,
      className: cx(variant, className)
    }, props)));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(icon, Object.assign({
    height: height,
    width: width,
    className: cx(variant, className)
  }, props)));
};
VariantIcon.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  variant: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export { VariantIcon as default };
//# sourceMappingURL=VariantIcon.js.map
